<script setup lang="ts">
  import type { HTMLAttributes } from 'vue'
  import { cn } from '../../../lib/utils'

  const props = defineProps<{
    class?: HTMLAttributes['class']
  }>()
</script>

<template>
  <td
    data-slot="table-cell"
    :class="
      cn(
        '*:[[role=checkbox]]:translate-y-0.5 whitespace-nowrap p-2 align-middle [&:has([role=checkbox])]:pr-0',
        props.class
      )
    "
  >
    <slot />
  </td>
</template>
